import {
  isDefined,
  Loadable,
  OrderExchangeData,
  OrderExchangeSummaryData,
  OrderFormData,
  OrderType,
} from '@eih-netbroker/common';

export const withOrderPriceForExanteCostPdf = <
  T extends {
    orderType: OrderType;
    price?: number | null;
  },
>(
  order: T,
): T => {
  if (order.orderType === OrderType.Market || order.orderType === OrderType.StopMarket) {
    return {
      ...order,
      price: null,
    };
  }
  return order;
};

export const createEmptyOrderForm = (userDefault: OrderFormData): OrderFormData => ({
  instrument: null,
  quantity: userDefault.quantity,
  price: undefined,
  stopActivationPrice: undefined,
  tradeType: undefined,
  orderType: undefined,
});

export const summarizedExchangeData = (exchangeData: OrderExchangeData): OrderExchangeSummaryData | undefined => {
  if (
    !exchangeData.isEnabled ||
    !Loadable.hasValue(exchangeData.exchangeRate) ||
    !Loadable.hasValue(exchangeData.settlementDate) ||
    !Loadable.hasValue(exchangeData.funding) ||
    !Loadable.hasValue(exchangeData.orderFields) ||
    !isDefined(exchangeData.fundingMode) ||
    !isDefined(exchangeData.selectedCurrency)
  ) {
    return undefined;
  }
  const { exchangeRate, settlementDate, selectedCurrency, orderFields, funding, fundingMode } = exchangeData;
  return {
    sourceCurrency: selectedCurrency,
    exchangeRate,
    settlementDate: settlementDate.date,
    costInTargetCurrency: fundingMode === 'missingAmount' ? funding.remaining.total - funding.missingAmount : 0,
    costInSourceCurrency: orderFields.currencySourceAmount,
  };
};
